import React from 'react'

import Skeleton from 'components_new/atoms/Skeleton'

export const Loading = (props: {
  scaleFactor: number
  showComparativePeriod: boolean
}) => {
  const { scaleFactor, showComparativePeriod } = props

  return (
    <>
      <>
        <Skeleton width="50%" height={14 * 1.5 * scaleFactor} />
        {showComparativePeriod ? (
          <Skeleton width="75%" height={14 * 1.5 * scaleFactor} />
        ) : null}
      </>
    </>
  )
}
